/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Non_OptionalInputs */



/**

* @param {Validation_Non_OptionalInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const validation_non_optional = /** @type {((inputs?: Validation_Non_OptionalInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Non_OptionalInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Dieses Feld darf nicht leer sein.")
});